import {
  Img,
  Heading,
  Row,
  Section,
  Column,
  Container,
} from "@react-email/components";
import { Text } from "@react-email/text";
import Footer from "../components/Footer";
import Header from "../components/Header";
import Layout from "../components/Layout";


export function template({
  organization_name,
  payout_amount,
  event_name,
  event_date,
  event_image_url,
  hold_amount,
  payment_date,
  cdn_url,
  hold_days,
}: {
  organization_name: string;
  payout_amount: string;
  event_name: string;
  event_date: string;
  event_image_url: string;
  hold_amount: string;
  payment_date: string;
  cdn_url: string;
  hold_days: number;
}) {
  return (
    <Layout language="en" title="Payout Completed">
      <Header src={`${cdn_url}/system/kyd-logo-email.png`} />
      <Container style={container}>
        <Text style={mainText}>
          {organization_name}, you've been paid out{" "}
          <strong>{payout_amount}</strong> for <strong>{event_name}</strong> on{" "}
          <strong>{payment_date}</strong>.{" "}
          <strong>See your breakdown below.</strong>
        </Text>
      </Container>

      {/* Table Header */}
      <Section style={tableHeaderSection}>
        <Row style={tableHeaderRow}>
          <Column style={tableHeaderLeftColumn}>
            <Text style={tableHeaderText}>Show Details</Text>
          </Column>
          <Column style={tableHeaderRightColumn}>
            <Text style={tableHeaderText}>Total Payout</Text>
          </Column>
        </Row>
      </Section>

      <Section>
        <Row>
          {/* 87px is the 80px + 7px padding */}
          <Column style={eventDetailsColumn}>
            <Row>
              <Column style={eventImageColumn}>
                <Img
                  src={event_image_url}
                  alt="Event Image"
                  width="100"
                  height="100"
                  style={eventImage}
                />
              </Column>
              <Column style={eventInfoColumn}>
                <Text style={eventName}>{event_name}</Text>
                <Text style={eventDate}>{event_date}</Text>
              </Column>
            </Row>
          </Column>
          <Column style={payoutAmountColumn}>
            <Text style={payoutAmount}>{payout_amount}</Text>
          </Column>
        </Row>
      </Section>

      <Section style={totalSection}>
        <Row>
          <Column style={totalLabelColumn}>
            <Text style={totalLabel}>TOTAL PAYOUT</Text>
          </Column>
          <Column style={dividerColumn1}>
            <div style={divider}></div>
          </Column>
          <Column style={dividerColumn2}>
            <div style={divider}></div>
          </Column>
          <Column style={totalAmountColumn}>
            <Text style={totalAmount}>{payout_amount}</Text>
          </Column>
        </Row>
      </Section>

      <Section style={noteSection}>
        <Text style={noteText}>
          This will be the payout amount you be receiving in your account in 3-5
          business days.
        </Text>
      </Section>

      <Section>
        <Heading as="h3" style={holdHeading}>
          Hold Details
        </Heading>
        <Text style={holdText}>
          There is <strong>{hold_amount} </strong> being held for this show to
          cover chargebacks, disputes, refunds, and agreed upon marketing costs
          for up to {hold_days} days. You will receive a payout notification when the
          hold is released.
        </Text>
      </Section>

      <Footer cdn_url={cdn_url} />
    </Layout>
  );
}

const container = { marginBottom: "24px" };
const mainText = { fontSize: "16px", color: "black", lineHeight: "24px" };
const tableHeaderSection = { marginBottom: "12px" };
const tableHeaderRow = {
  backgroundColor: "#F1ECEC50",
  paddingLeft: "7px",
  paddingRight: "7px",
  paddingTop: "4px",
  paddingBottom: "4px",
  marginBottom: "12px",
};
const tableHeaderLeftColumn = { width: "calc(100% - 80px)" };
const tableHeaderRightColumn = { width: "80px", textAlign: "left" as const };
const tableHeaderText = { fontSize: "14px", color: "black", margin: "0" };
const eventDetailsColumn = {
  width: "calc(100% - 87px)",
  verticalAlign: "middle",
  paddingLeft: "4px",
};
const eventImageColumn = { width: "10%", verticalAlign: "middle" };
const eventImage = {
  display: "block",
  border: "1px solid #EAEAEA",
  borderRadius: "10px",
};
const eventInfoColumn = {
  paddingLeft: "11px",
  verticalAlign: "top",
};
const eventName = {
  fontSize: "14px",
  fontWeight: "bold",
  color: "black",
  marginTop: "0",
  marginBottom: "0",
  paddingTop: "0",
  paddingBottom: "0",
  textAlign: "left" as const,
  maxWidth: "120px",
  overflow: "hidden",
  textOverflow: "ellipsis",
  display: "-webkit-box",
  WebkitLineClamp: 2,
  WebkitBoxOrient: "vertical" as const,
};
const eventDate = {
  fontSize: "12px",
  color: "black",
  marginTop: "0",
  paddingTop: "0",
  textAlign: "left" as const,
};
const payoutAmountColumn = {
  width: "87px",
  verticalAlign: "top",
  textAlign: "left" as const,
};
const payoutAmount = {
  fontSize: "14px",
  color: "black",
  fontWeight: "500",
  marginTop: "0px",
};
const totalSection = {
  marginTop: "32px",
  borderTop: "0.5px solid #EBEBEB",
  borderBottom: "0.5px solid #EBEBEB",
};
const totalLabelColumn = {
  width: "calc(100% - 87px)",
  textAlign: "right" as const,
};
const totalLabel = {
  fontSize: "14px",
  fontWeight: "500",
  color: "black",
};
const dividerColumn1 = {
  width: "2%",
  textAlign: "center" as const,
  paddingLeft: "4px",
  paddingRight: "4px",
  borderRight: "0.5px solid #EBEBEB",
};
const dividerColumn2 = {
  width: "2%",
  textAlign: "center" as const,
  paddingLeft: "4px",
  paddingRight: "4px",
};
const divider = {
  width: "1px",
  height: "100%",
  backgroundColor: "#999",
  margin: "0 auto",
};
const totalAmountColumn = { width: "87px", textAlign: "left" as const };
const totalAmount = { fontSize: "14px", color: "black", fontWeight: "500" };
const noteSection = { borderBottom: "0.5px solid #EBEBEB" };
const noteText = { fontStyle: "italic", fontSize: "12px", color: "black" };
const holdHeading = { fontSize: "16px", marginBottom: "8px", color: "black" };
const holdText = { fontSize: "12px", lineHeight: "18px", color: "black" };

template.PreviewProps = {
  organization_name: "Organization Name",
  payout_amount: "$10,000",
  event_name: "Test Event",
  event_date: "March 19 2025",
  event_image_url: "https://via.placeholder.com/100",
  hold_amount: "200",
  payment_date: "March 19 2025",
  cdn_url: "https://cdn.example.com",
  hold_days: 60,
};

export default template;
